export enum PermissionFlags {
  ReadMy = 1 << 0,       // 1
  CreateMy = 1 << 1,     // 2
  UpdateMy = 1 << 2,     // 4
  DeleteMy = 1 << 3,     // 8

  ReadHierarchy = 1 << 4,   // 16
  CreateHierarchy = 1 << 5, // 32
  UpdateHierarchy = 1 << 6, // 64
  DeleteHierarchy = 1 << 7, // 128
}